// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"form-sucess_wrapper__9Zda7","icon":"form-sucess_icon__vNNd1","svg":"form-sucess_svg__er0nz","title":"form-sucess_title__zhsnw","text":"form-sucess_text__sg8xY"};